// Gatsby requirements
import React from 'react'
import { Link } from 'gatsby'

// Components
import SeoStructuredData from './seoStructuredData'

// Styles
import * as CSS from './breadcrumbs.module.scss'


const Breadcrumbs = ({ currentPage, currentPageName }) => {

    const splitURL = currentPage && currentPage.toString().split("/").filter((a) => a);

    return (
        <nav aria-label="breadcrumbs" className={`${CSS.crumbs} wrapper`}>

            {currentPage &&
                <SeoStructuredData data={
                    `{
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            {
                                "@type": "ListItem",
                                "position": 1,
                                "name": "WA.nl",
                                "item": "/"
                            },
                        ${splitURL.map((loop, i) => (
                            `{
                                "@type": "ListItem",
                                "position": ${i + 2},
                                "name": "${splitURL.length === i + 1 ? currentPageName : loop.replace(/-/g, " ")}",
                                "item": "${
                                    i === 0 ? '/' + loop + '/': 
                                    i === 1 ? '/' + splitURL[0] + '/' + loop + '/' : 
                                    i === 2 ? '/' + splitURL[0] + '/' + splitURL[1] + '/' + loop + '/' : 
                                    i === 3 ? '/' + splitURL[0] + '/' + splitURL[1] + '/' + splitURL[2] + '/' + loop + '/' : ''
                                }"
                            }`
                        ))}
                        ]
                    }
                `
                } />
            }
            
            <ol>
                <li><Link to="/">WA.nl</Link></li>
                {splitURL?.map((loop, i) => (
                    <li key={i}>
                        {i === 0 && loop !== "" && <Link to={'/' + loop + '/'}>{splitURL.length === i + 1 ? currentPageName : loop.replace(/-/g, " ")}</Link>}
                        {i === 1 && loop !== "" && <Link to={'/' + splitURL[0] + '/' + loop + '/'}>{splitURL.length === i + 1 ? currentPageName : loop.replace(/-/g, " ")}</Link>}
                        {i === 2 && loop !== "" && <Link to={'/' + splitURL[0] + '/' + splitURL[1] + '/' + loop + '/'}>{splitURL.length === i + 1  ? currentPageName : loop.replace(/-/g, " ")}</Link>}
                        {i === 3 && loop !== "" && <Link to={'/' + splitURL[0] + '/' + splitURL[1] + '/' + splitURL[2] + '/' + loop + '/'}>{splitURL.length === i + 1  ? currentPageName : loop.replace(/-/g, " ")}</Link>}
                    </li>

                ))}
            </ol>
        </nav>
    )
}

export default Breadcrumbs